// @flow

import React, { Component } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import axios from 'axios';
import toast from 'react-simple-toasts';

// css for progress style
import 'react-circular-progressbar/dist/styles.css';

import Config from '../../config';
import { ct } from '../../constant-Utils';
import { Constant } from '../../../webjam/constant';
const { socket_endpoint } = Config;

let call;

export default class UploadFiles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isfileUploaded: false,
      percentage: 0,
      fileName: ''
    };

    this.fileSubmit = this.fileSubmit.bind(this);
    this.fileUpload = this.fileUpload.bind(this);
    this.uploadRef = React.createRef();

  }

  fileSubmit(e) {

    console.log("file detail ", e.target.files[0])
    this.fileUpload(e.target.files[0]).then((response) => {

      this.setState({
        isfileUploaded: true,
        fileName: response.data.data.name,
        percentage: 0
      });

      this.send();
    }).catch(e => {
      toast(e?.message || ct("rta-trmc.rtaInviteModal.somethingWentWrong"), Constant.App.ToastTime.LongCloseTime);
    });
  }

  send = () => {
    const { fileName } = this.state;
    const { onSend } = this.props;

    if (fileName) {
      onSend(fileName);
    } else {
      alert(ct("rta-trmc.dialogs.unableToSend"));
    }

    this.setState({
      fileName: '',
      isfileUploaded: false,
    })
  }

  clickOnFile() {
    this.uploadRef.current.click();
  }


  fileUpload(file) {
    const { appBaseUrls } = this.props;

    const url = `${socket_endpoint}/upload`;

    //const url = "https://live.realtimeaudio.com:3000/upload";
    const formData = new FormData();
    let fileName = file.name.replace(/\s/g, "");
    formData.append('file', file, fileName);

    if (call) {
      call.cancel("Only one request allowed at a time.");
    }

    call = axios.CancelToken.source();

    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      },
      cancelToken: call.token,
      onUploadProgress: (progressEvent) => {

        // const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');

        const totalLength = progressEvent.total

        if (totalLength !== null) {
          const progressData = Math.round((progressEvent.loaded * 100) / totalLength);
          this.setState({
            percentage: progressData
          })
        }
      }
    }

    return axios.post(url, formData, config);
  }

  render() {

    const { percentage, isfileUploaded, fileName } = this.state;
    return (
      <div className="file_upload">
        {!isfileUploaded && !percentage &&
          <div className="file-data">
            <label htmlFor="file-input" style={{ cursor: 'pointer' }}>
              <i className="fa fa-paperclip fa-lg" style={{ color: 'white', padding: "10px 6px" }}
              // onClick={this.clickOnFile}
              ></i>
            </label>
            <input id="file-input"

              // ref={this.uploadRef} 

              onChange={this.fileSubmit} type="file" style={{ display: 'none' }} />
          </div>
        }

        {percentage > 0 &&
          <div style={{ width: '40px', height: '40px' }} className='upload-percentage'  >
            <CircularProgressbar value={percentage} text={`${percentage}%`} />
          </div>
        }
      </div>
    )
  }
}